var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-question", class: { small: _vm.small } },
    [
      _c(
        "v-popover",
        { attrs: { offset: "5", trigger: "hover" } },
        [
          _c("div", { staticClass: "quest" }),
          _vm._v(" "),
          _c("template", { slot: "popover" }, [
            _c("p", { staticClass: "v-question__content" }, [
              _vm._v("\n        " + _vm._s(_vm.content) + "\n      ")
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }